import React from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import axios from "axios";
import API from "../helpers/api";
import swal from "sweetalert";
import { toast } from "react-toastify";

let user = JSON.parse(localStorage.getItem("currentUser"));

class TechExecutiveManagementAdd extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            TechExecutiveinfo: {
                name: '',
                role: 'technicalexecutive',
                email: '',
                phone: '',
                createdBy: ''
            },
            index: 0,
        }
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount() {
        this.props.dispatch({ type: 'SubBannerTitle', data: "Technical Executive" });
    } 

    handleInputChange(e) {
        let nodeName = e.target.name;
        this.state.TechExecutiveinfo[nodeName] = e.target.value;
        this.setState({});
    }

    addTechExecutive() {
        const { dispatch } = this.props;
        if (this.state.TechExecutiveinfo.email !== "" && this.state.TechExecutiveinfo.name !== "") {
            var pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          if (!pattern.test(this.state.TechExecutiveinfo.email)) {
            swal('Error!', 'Invalid Email', 'warning');
            }else{
            let url2 = `${API.userExist}?Mail=${this.state.TechExecutiveinfo.email}&Id=${0}&Role=${this.state.TechExecutiveinfo.role}`
            axios.get(url2, {
                headers: {
                    key: user.accessToken
                }
            })
                .then((response) => {
                    if (response.data === true) {
                        let url = `${API.PutClientUsers}`;
                        let userData = 
                          {
                            clientUserId:0 ,
                            role: this.state.TechExecutiveinfo.role,
                            name: this.state.TechExecutiveinfo.name,
                            email:this.state.TechExecutiveinfo.email,
                            address: "",
                            phone: this.state.TechExecutiveinfo.phone,
                            isDeleted: false,
                            modifiedBy:user.email
                            
                          }
                        axios.put(url, userData, {
                        headers: {
                            key: user.accessToken,
                        },
                     })
              .then((response) => {
                  if(response.status===200){
                    toast.success("Added Successfully", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                      });
                        this.hideSidePanel();
                        dispatch({
                            type: "postClientUserDetailsSuccess",
                            data: response.data,
                       });
                      }
                   })
                        .catch((error) => {
                            swal(
                                "Error!",
                                "Something went wrong. Please try again.",
                                "warning"
                              );
                            dispatch({
                                type: "postClientUserDetailsFailure",
                                error: "ERROR",
                              });
                            });
                    } else if (response.data === false) {
                        swal('Error!', 'User already exist. Please change the email', 'warning');
                        this.state.TechExecutiveinfo.email = "";
                        this.setState({});
                    }
                    dispatch({
                        type: 'getUserExistListSuccess',
                        data: response.data
                    })
                })
                .catch((error) => {
                    dispatch({
                        type: 'getUserExistListFailure',
                        data: "error"
                    })
                })
            }
        } else if(this.state.TechExecutiveinfo.name === "" && this.state.TechExecutiveinfo.email === "") {
            swal('Error!', 'Name and Email is mandatory', 'warning');
        } else if(this.state.TechExecutiveinfo.name === "") {
            swal('Error!', 'Name is mandatory', 'warning');
        } else {
            swal('Error!', 'Email is mandatory', 'warning');
        }
    }


    hideSidePanel() {
        this.props.dispatch({ type: "ShowSidePan", data: false });
        this.props.history.push("/Home/Management/TechExecutive");
    }

    render() {
        const { editUser } = this.props;
        return (
            <div className="full-height">
                <div className="resource-list-auth-date row pt-3 ">
                    <div className='w-100'>
                        <div className="panel-box search-filter-box">
                           
                            <div className="card mt-2 MM-card-header" style={{ backgroundColor: "white" }}>
                                <div className="card-body" style={{ padding: "0rem", backgroundColor: "#1E3A8A", color: "white" }}><h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>Technical Executive</h5></div>
                            </div>
                            <div className="row search-filter-box">
                                <div className="col-lg-4">
                                    <label className="form-label">Name</label><br></br>
                                    <input type="text" className="form-control" name='name' value={this.state.TechExecutiveinfo.name} placeholder="Name" onChange={e => this.handleInputChange(e)}></input>
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Email</label><br></br>
                                    <input type="email" className="form-control" name='email' value={this.state.TechExecutiveinfo.email} placeholder="Email" onChange={e => this.handleInputChange(e)}></input>
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Phone</label><br></br>
                                    <input type="text" className="form-control" name='phone' value={this.state.TechExecutiveinfo.phone} placeholder="Phone" onChange={e => this.handleInputChange(e)}></input>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12 search-filter-box">
                                    <div className="search-btn-col" style={{ textAlign: 'end' }}>
                                        
                                            <button className="btn btn-primary text-uppercase txtside-btn txtht-btn blue" type="submit" onClick={() => this.addTechExecutive()}> Submit </button>
                                        <button className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3" type="button" onClick={() => this.hideSidePanel()}> Cancel </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    }
}
function mapStateToProps(state) {
    return {
        editUser: state.MasterScreenReducer.editUser,
        TechExecutiveDetail: state.MasterScreenReducer.TechExecutiveDetail,
        TechExecutivelist: state.MasterScreenReducer.TechExecutivelist,
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TechExecutiveManagementAdd));